import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import Quasar from 'quasar/src/vue-plugin.js';import Notify from 'quasar/src/plugins/notify/Notify.js';
import './assets/main.css'
import '@quasar/extras/material-icons/material-icons.css'
import 'quasar/src/css/index.sass'
import quasarUserOptions from './quasar-user-options'
import '@/firebase'

createApp(App).use(Quasar, quasarUserOptions).use(router).mount('#app')
